import React from 'react';

const S = ({
    w = 'w-full',
    h = 'h-4',
    r = 'rounded-lg',
    cls = '',
}: {
    w?: string;
    h?: string;
    r?: string;
    cls?: string;
}) => (
    <div
        className={`${w} ${h} ${r} ${cls} flex-shrink-0`}
        style={{
            background: 'linear-gradient(90deg,var(--v2-border-subtle) 25%,var(--v2-border-card) 50%,var(--v2-border-subtle) 75%)',
            backgroundSize: '200% 100%',
            animation: 'skeletonShimmer 1.6s ease-in-out infinite',
        }}
    />
);

const TestCatalogSkeleton: React.FC = () => (
    <div className="flex flex-col gap-4 v2-animate-fade-in">

        {/* Toolbar */}
        <div className="flex items-center gap-2 flex-wrap">
            <S w="w-64" h="h-9" r="rounded-xl" />
            <S w="w-40" h="h-9" r="rounded-xl" />
            <div className="ml-auto flex items-center gap-2">
                <S w="w-28" h="h-9" r="rounded-xl" />
            </div>
        </div>

        {/* Table */}
        <div className="rounded-2xl border border-[var(--v2-border-card)] bg-[var(--v2-bg-card)] overflow-hidden" style={{ boxShadow: 'var(--v2-shadow-card)' }}>
            {/* Column headers */}
            <div className="flex items-center gap-4 px-4 py-2.5 border-b border-[var(--v2-border-subtle)]">
                {[200, 100, 80, 80, 72, 80].map((w, i) => (
                    <S key={i} w={`w-[${w}px]`} h="h-2.5" r="rounded-md" />
                ))}
            </div>
            {/* Rows */}
            {Array.from({ length: 8 }).map((_, i) => (
                <div key={i} className="flex items-center gap-4 px-4 py-3 border-b border-[var(--v2-border-divider)] last:border-0">
                    <S w="w-[200px]" h="h-3" r="rounded-md" />
                    <S w="w-[100px]" h="h-2.5" r="rounded-md" />
                    <S w="w-[80px]" h="h-5" r="rounded-full" />
                    <S w="w-[80px]" h="h-2.5" r="rounded-md" />
                    <S w="w-[72px]" h="h-2.5" r="rounded-md" />
                    <div className="ml-auto flex gap-1.5">
                        <S w="w-7" h="h-7" r="rounded-lg" />
                        <S w="w-7" h="h-7" r="rounded-lg" />
                        <S w="w-7" h="h-7" r="rounded-lg" />
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default TestCatalogSkeleton;
